import clsx from 'clsx'
import React from 'react'

import { useNode } from '@craftjs/core'
import { Text } from '@wartek-id/text'

import type { IHeading as HeadingInterface } from './typings'
import { HeadingSize } from './typings'

const Heading = ({ text, size = HeadingSize.MD }: HeadingInterface) => {
  const {
    connectors: { connect, drag },
    isSelected,
  } = useNode((node) => ({
    isSelected: node.events.selected,
  }))

  return (
    <Text
      ref={(ref) => connect(drag(ref!))}
      className={clsx(
        'widget-component',
        'mb-2 last:mb-0',
        isSelected && 'widget-component__selected'
      )}
      variant={size}
    >
      {text}
    </Text>
  )
}

export default Heading
